import CoordinatePage from 'components/coordinate/CoordinatePage';
import CoordinateRequestPage from 'components/coordinateRequest/CoordinateRequestPage';
import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';

function CoordinateIndex() {
  const { profile } = useProfile();
  const showCoordinateRequest =
    profile.actingClient.providedProviderTypes.length > 0 && profile.has(PERMISSIONS.reviewCoordinateRequestCreate);
  return showCoordinateRequest ? <CoordinateRequestPage /> : <CoordinatePage />;
}

export default CoordinateIndex;
